
import FearAndGreedIndex from '@/components/marketAnalysis/FearAndGreedIndex';
import MarketAnalysisChartWidget from '@/components/marketAnalysis/MarketAnalysisChartWidget';
import { kpiBoxCardTypes } from '@/constants/marketAnalysis';

export default {
    name: 'MarketKpiCard',

    components: {
        FearAndGreedIndex,
        MarketAnalysisChartWidget,
    },

    props: {
        initType: {
            type: String,
            required: true
        },
        cardNumber: {
            type: Number,
            required: true
        },
        data: {
            type: Object,
            default: () => ({})
        },
        isInitializing: {
            type: Boolean,
            default: true
        },
        isLoading: {
            type: Boolean,
            default: true
        }
    },
    emits: ['card-type-changed'],
    data() {
        return {
            type: null,
        }
    },
    computed: {
        title() {
            if (!this.type) {
                return ''
            }
            const titleMapping = {
                [kpiBoxCardTypes.fearAndGreed]: this.$t('pages.marketAnalysis.card.fearAndGreedIndex.title'),
                [kpiBoxCardTypes.vix]: this.$t('pages.marketAnalysis.card.vix.title'),
                [kpiBoxCardTypes.consumerSentiment]: this.$t('pages.marketAnalysis.card.consumerSentiment.title'),
                [kpiBoxCardTypes.usInflationRate]: this.$t('pages.marketAnalysis.card.usInflationRate.title'),
                [kpiBoxCardTypes.fedInterestRate]: this.$t('pages.marketAnalysis.card.fedInterestRate.title'),
                [kpiBoxCardTypes.initialClaims]: this.$t('pages.marketAnalysis.card.initialClaims.title'),
            }

            return titleMapping[this.type]
        },
        tooltipContent() {
            if (!this.type) {
                return ''
            }
            const tooltipContentMapping = {
                [kpiBoxCardTypes.fearAndGreed]: this.$t('pages.marketAnalysis.card.fearAndGreedIndex.tooltip'),
                [kpiBoxCardTypes.vix]: this.$t('pages.marketAnalysis.card.vix.tooltip'),
                [kpiBoxCardTypes.consumerSentiment]: this.$t('pages.marketAnalysis.card.consumerSentiment.tooltip'),
                [kpiBoxCardTypes.usInflationRate]: this.$t('pages.marketAnalysis.card.usInflationRate.tooltip'),
                [kpiBoxCardTypes.fedInterestRate]: this.$t('pages.marketAnalysis.card.fedInterestRate.tooltip'),
                [kpiBoxCardTypes.initialClaims]: this.$t('pages.marketAnalysis.card.initialClaims.tooltip'),
            }

            return tooltipContentMapping[this.type]
        },
        cardTypes() {
            return [
                {
                    text: this.$t('pages.marketAnalysis.card.fearAndGreedIndex.label'),
                    value: kpiBoxCardTypes.fearAndGreed
                },
                {
                    text: this.$t('pages.marketAnalysis.card.vix.label'),
                    value: kpiBoxCardTypes.vix
                },
                {
                    text: this.$t('pages.marketAnalysis.card.consumerSentiment.label'),
                    value: kpiBoxCardTypes.consumerSentiment
                },
                {
                    text: this.$t('pages.marketAnalysis.card.usInflationRate.label'),
                    value: kpiBoxCardTypes.usInflationRate
                },
                {
                    text: this.$t('pages.marketAnalysis.card.fedInterestRate.label'),
                    value: kpiBoxCardTypes.fedInterestRate
                },
                {
                    text: this.$t('pages.marketAnalysis.card.initialClaims.label'),
                    value: kpiBoxCardTypes.initialClaims
                },
            ]
        },
        isLoggedIn() {
            return !!this.$store.state.account.user
        },
    },

    watch: {
        initType: {
            immediate: true,
            handler(type) {
                this.type = type
            }
        }
    },

    created() {
        this.kpiBoxCardTypes = kpiBoxCardTypes
    },

    methods: {
        cardTypeChanged(newType) {
            this.type = newType
            const payload = {
                cardType: newType,
                position: this.cardNumber
            }
            this.$emit('card-type-changed', payload)
        }
    }
}
